import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../juristec-ui/core/Button/Button';
import DatePicker from '../../../juristec-ui/core/DatePicker/DatePicker';

import {
  FilterContainer,
  ActionGroup,
} from './styled/DateFilter.styled';

const dateInputFilterDefaultPropClose = () => { };
const dateInputFilterDefaultPropHandleFilter = () => { };

const DateFilter = ({
  controlValue = '',
  close = dateInputFilterDefaultPropClose,
  handleFilter = dateInputFilterDefaultPropHandleFilter,
  label = '',
}) => {
  const initialDate = controlValue ? new Date(controlValue) : null;
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (controlValue && !isDirty) {
      setSelectedDate(new Date(controlValue));
    }
  }, [controlValue]);

  const handleDateChange = (date) => {
    setIsDirty(true);
    setSelectedDate(date);
  };

  const handleApply = () => {
    const isoDate = selectedDate ? selectedDate.toISOString() : '';
    handleFilter([isoDate]);
    close();
  };

  return (
    <FilterContainer onMouseDown={(e) => e.stopPropagation()}>
      <ActionGroup>
        <Button
          size="small"
          variant="outlined"
          onClick={close}
          style={{ width: '100%', minWidth: '100px' }}
        >
          Cancelar
        </Button>
        <Button
          size="small"
          onClick={handleApply}
          disabled={!isDirty}
          style={{ width: '100%', minWidth: '100px' }}
        >
          Aplicar
        </Button>
      </ActionGroup>

      <DatePicker
        value={selectedDate}
        label={label || 'Selecionar data'}
        onChange={handleDateChange}
        isClearable
      />
    </FilterContainer>
  );
};

DateFilter.propTypes = {
  controlValue: PropTypes.string,
  close: PropTypes.func,
  handleFilter: PropTypes.func,
  label: PropTypes.string,
};

export default DateFilter;
